<template>
  <div>
    <div style="background-color: #fff; text-align: center; padding: 15px 0 10px 0; margin-bottom: 3px;">
      <img v-lazy="this.shopLogo" style="width: 100%; max-height: 106px; max-width: 414px;">
    </div>
    <van-cell-group>
      <van-cell :title="generateCustomizeString('shopName')" :value="shopName" />
      <van-cell :title="generateCustomizeString('username')" :value="name" />
      <van-cell title="Language">
        <van-button size="small" square style="color: #1989fa;" @click="en" v-if="this.$i18n.locale === 'zh'">EN</van-button>
        <van-button size="small" square style="color: #fff; background-color: #1989fa;" disabled v-else>EN</van-button>
        <van-button size="small" square style="margin-left: -6px; color: #1989fa;" @click="cn" v-if="this.$i18n.locale === 'en'">中文</van-button>
        <van-button size="small" square style="margin-left: -6px; color: #fff; background-color: #1989fa;" disabled v-else>中文</van-button>
      </van-cell>
    </van-cell-group>

    <van-cell-group>
      <van-button type="danger" size="large" @click="logout">{{ generateCustomizeString('logout') }}</van-button>
    </van-cell-group>

  </div>
</template>

<script>
import { generateCustomizeString } from '@/utils/i18n'
import { Field, Cell, CellGroup, Row, Col, Button, Toast } from 'vant'
import store from '@/store'
import { fetchBasicShopInfo } from '@/utils/api/shop'

export default {
  name: 'person',
  components: {
    [Cell.name]: Cell,
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [Row.name]: Row,
    [Col.name]: Col,
    [Button.name]: Button
  },
  data() {
    return {
      name: store.getters.name,
      shopName: '',
      shopLogo: ''
    }
  },
  methods: {
    generateCustomizeString,
    en() {
      Toast.success('The language has been changed to English')
      this.$i18n.locale = 'en'
      this.$store.dispatch('setLanguage', 'en')
    },
    cn() {
      Toast.success('语言已切换为中文')
      this.$i18n.locale = 'zh'
      this.$store.dispatch('setLanguage', 'zh')
    },
    logout() {
      this.$store.dispatch('LogOut').then(() => {
        location.reload() // 为了重新实例化vue-router对象 避免bug
      })
    }
  },
  created: function() {
    fetchBasicShopInfo().then(response => {
      this.shopName = response.data.display_shop_name
      this.shopLogo = response.data.shop_logo_url + '?imageView2/0/w/500/q/75|imageslim'
    }).catch(error => {
      console.log(error)
    })
    console.log(this.$i18n.locale)
  }
}
</script>

<style scoped>
</style>
<style type="text/css">
.van-button--small {
  height: 30px;
  padding: 0 8px;
  min-width: 50px;
  font-size: 12px;
  line-height: 28px;
}
.van-toast--default {
  width: 190px;
  min-height: 130px;
}
</style>
